import { render } from "./ReporteTurnoModal.vue?vue&type=template&id=2f126766&scoped=true"
import script from "./ReporteTurnoModal.vue?vue&type=script&lang=js"
export * from "./ReporteTurnoModal.vue?vue&type=script&lang=js"

import "./ReporteTurnoModal.vue?vue&type=style&index=0&id=2f126766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f126766"]])

export default __exports__